import {
  ValidatorFn,
  ValidationErrors,
  AbstractControl,
  FormGroup,
} from '@angular/forms';

export function AddressValidator(addressGroup: FormGroup): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let controls = Object.entries(addressGroup.controls);
    let errors = controls
      .filter(([controlName, control]) => !control.valid)
      .map(([controlName, control]) => controlName);

    if (errors.length === 0) {
      return null;
    } else {
      return { missingAddressField: errors };
    }
  };
}
